import { render } from "./SanadMenu.vue?vue&type=template&id=4c642590"
import script from "./SanadMenu.vue?vue&type=script&lang=js"
export * from "./SanadMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__